/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.Client {
  angular.module("meevo.plugins.client", []);
}